import React from 'react';

export default function FeatureSelectAll( props ) {
    const {height, onClick, isAllSelected } = props;

    return (
        <div className="inline-flex items-center hover:bg-purple-100" onClick={onClick} style={{height, borderBottom: '1px solid #dddddd'}}>
            <input type="checkbox" className="form-checkbox mx-2 h-4 w-4" defaultChecked={isAllSelected} />
            <span className="text-md text-gray-800">Select All</span>
        </div>
    )
}